import React from 'react';
import { Card, CardHeader, CardContent, IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import dlv from 'dlv';

const GraphCard = (props) => {
  const cardStyle = {
    margin: '4px',
    borderRadius: '16px',
  };
  let dropdownMenu = null;
  if (props.dispOptions) {
    // creates options/activeOptions arrays
    const dropdownOps = [{ label: 'All', id: '*' }];
    const dropdownActiveOps = [];
    if (props.allActive) {
      dropdownActiveOps.push({ lable: 'All', id: '*' });
    }
    props.options.forEach((item, i) => {
      dropdownOps.push({ label: item, value: i });
      let itemIsActive = dlv(props.activeOps, `${item}`, false);
      if (itemIsActive) {
        dropdownActiveOps.push({ label: item, value: i });
      }
    });
    dropdownMenu = (
      <ReactMultiSelectCheckboxes
        options={dropdownOps}
        value={dropdownActiveOps}
        onChange={props.changer}
      />
    );
  }

  return (
    <Card style={cardStyle}>
      <CardHeader
        action={
          <IconButton aria-label="options">
            <MoreVertIcon />
          </IconButton>
        }
        title={props.title}
        subheader={dropdownMenu}
      />
      <CardContent>{props.plot}</CardContent>
    </Card>
  );
};

export default GraphCard;
